module.exports = __webpack_public_path__ + "img/caution.550e265b.png";